module.exports = __webpack_public_path__ + "static/img/2.200d0f6.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/why/2.png
// module id = auM8
// module chunks = 1